import React, { useEffect, useState } from 'react';
import { Button, FormControl, InputLabel, MenuItem, OutlinedInput } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import nest from '../../../services/nest';
import { getUserId } from '../../../services/auth';
import Select from '@mui/material/Select';
import Loading from '../../../components/Loading';



function ModalEditUser({mostrar, handleClose, loadOutrosUsuariosAbaixo, idUsuarioDependente, setAlerta, list}) {
    let initialized = false;
    const [itemsCargo, setItemsCargo] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemsSetor, setItemsSetor] = useState([]);
    const [form, setForm] = useState({
        nome: '',
        email: '',
        CargoValue: '',
        SetorValue: '',
    });
   
    const fetchSetor = async () => {
        nest.get("/cliente/cliente-usuario-setores")
        .then((response) => {
            setItemsSetor(response.data);
        });
    };
    const fetchCargo = async () => {
       nest.get("/cliente/cliente-usuario-cargos")
        .then((response) => {
            setItemsCargo(response.data);
        })
    };
    useEffect(() => {
        if (!initialized) {
            fetchSetor();
            fetchCargo();
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initialized = true;
        }
    }, []);
    useEffect(() => {
        if(mostrar && list.length > 0){
            const usuario = list.find(item => item.id === idUsuarioDependente);
            if(usuario){
                setForm({
                    nome: usuario.nome || '',
                    email: usuario.email || '',
                    CargoValue: usuario.cargo_id || '',
                    SetorValue: usuario.setor_id || '',
                });
            }
        }
    }, [mostrar, idUsuarioDependente, list]);
    const atualizarUsuario = async () => {
        if(!form.CargoValue){
            setAlerta({
                status: true,
                msg: 'Selecione o cargo!',
                type: 'error'
            })
            return false;
        }
        if(!form.SetorValue){
            setAlerta({
                status: true,
                msg: 'Selecione o setor!',
                type: 'error'
            })
            return false;
        }

        let clienteUsuarioId = await getUserId();
        setLoading(true);
        const data = {
          cargo_id: form.CargoValue,
          setor_id: form.SetorValue,
          conta_master_id: clienteUsuarioId,
          cliente_usuario_id: idUsuarioDependente,
        };
        nest.put( "/cliente/cliente-usuarios/editarUsuario",
            data
        ).then(function (response) {
            loadOutrosUsuariosAbaixo();
            setLoading(false);
            handleClose();
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
        });
    }
    return (
        <Modal show={mostrar} onHide={handleClose} centered>
            <Loading open={loading} />
            <Modal.Header closeButton style={{paddingTop: 10, paddingBottom: 10}}>
                <Modal.Title style={{
                    color: "var(--main-bg-color)", 
                    width: "100%", 
                    textAlign: 'center',
                }}>Editar usuário</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div style={{marginLeft: 50,marginRight: 50, marginTop: 0}}>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel>Nome</InputLabel>
                    <OutlinedInput
                      type="text"
                      value={form.nome}
                      disabled
                      label="Nome"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel>E-mail</InputLabel>
                    <OutlinedInput
                      label="E-mail"
                      value={form.email}
                      type="email"
                      disabled
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel id="turno">Cargo</InputLabel>
                    <Select
                    labelId="turno"
                    value={form.CargoValue}
                    label="Cargo"
                    onChange={(e) => setForm({ ...form, CargoValue: e.target.value })}
                    >
                    <MenuItem disabled value=""><em>Selecione um cargo</em></MenuItem>
                    {itemsCargo.length > 0 && (
                        itemsCargo.map((element, index) => (
                            <MenuItem key={index} value={element.id}>{element.nome}</MenuItem>
                        ))
                    )}
                    </Select>
                </FormControl>
                <FormControl sx={{ m: 1, width: '100%' }} variant="outlined">
                    <InputLabel id="turno">Setor</InputLabel>
                    <Select
                    labelId="turno"
                    value={form.SetorValue}
                    label="Setor"
                    onChange={(e) => setForm({ ...form, SetorValue: e.target.value })}
                    >
                    <MenuItem disabled value=""><em>Selecione um setor</em></MenuItem>
                    {itemsSetor.length > 0 && (
                        itemsSetor.map((element, index) => (
                            <MenuItem key={index} value={element.id}>{element.nome}</MenuItem>
                        ))
                    )}
                    </Select>
                </FormControl>
            </div>
            </Modal.Body>
            <Modal.Footer>
                <div  onClick={() => handleClose()}>
                    <Button style={{backgroundColor: "#a3a3a3"}} variant="contained">
                       Cancelar
                    </Button>
                </div>
                <div  onClick={() => atualizarUsuario()}>
                    <Button style={{backgroundColor: "var(--main-bg-color)"}} variant="contained" disabled={loading}>
                       Atualizar
                    </Button>
                </div>
            </Modal.Footer>
            
        </Modal>
    );
}

export default ModalEditUser;